import { TableInfo } from '@Components/ViewWork/Table'
import React, { useContext, useMemo } from 'react'
import CellInput from '@Components/ViewWork/Table/ValidationCells/CellInput'
import { titleTypeOptions } from '@Const/options/dropdown-options'
import { SelectOption } from '@Components/Selectors/Select'
import _, { difference } from 'lodash'
import { StoresContext } from '@App/contexts'
import { OptionModel } from '@Entities/lib'
import { AlternativeTitleModel } from '@Entities/work/alternative-title-model'

const AlternativeTitlesTableInfo = (): TableInfo[] => {
    const { workStore, libStore } = useContext(StoresContext)

    const workDraftFromLocal = workStore.workDraftLocal

    if (!workDraftFromLocal) {
        return []
    }

    const workById = workStore.workById

    const languageOptions: OptionModel[] = libStore.languages

    const akaTitles = workDraftFromLocal.alternativeTitles
    const akaTitlesFromWork: AlternativeTitleModel[] =
        workDraftFromLocal.id && workDraftFromLocal.isComplete && workById ? workById.alternativeTitles : []

    // MPOR-1684: See comment on ReviewWorkFormScene file for details on the currentAkaTitles.length line I added.
    const currentAkaTitles: AlternativeTitleModel[] = akaTitlesFromWork ? difference(akaTitles, akaTitlesFromWork) : []

    return useMemo(() => {
        const alternativeTitlesSource = akaTitlesFromWork ? currentAkaTitles : akaTitles
        const rows = alternativeTitlesSource.map((data: AlternativeTitleModel, index: number) => ({
            removeCellIdentifier: '',
            removable: true,
            cells: [
                <CellInput
                    defaultValue={data.title}
                    readOnly
                    name={`rows[${index}].alternativeTitleName`}
                    key={`${_.uniqueId()}.alternativeTitleName`}
                    type="text"
                />,
                <CellInput
                    defaultValue={
                        data.titleType
                            ? titleTypeOptions.find((option: SelectOption) => +option.id === data.titleType)?.label
                            : null
                    }
                    readOnly
                    name={`rows[${index}].alternativeTitleType`}
                    key={`${_.uniqueId()}.alternativeTitleType`}
                    type="text"
                />,
                <CellInput
                    defaultValue={
                        data.languageCode
                            ? languageOptions.find((option) => +option.id === data.languageCode)?.label
                            : null
                    }
                    readOnly
                    name={`rows[${index}].alternativeTitleLanguage`}
                    key={`${_.uniqueId()}.alternativeTitleLanguage`}
                    type="text"
                />,
            ],
        }))

        return [
            {
                headerRow: {
                    row: [{ text: 'Alternative Title' }, { text: 'Alternative Title Type' }, { text: 'Language' }],
                    removableCells: true,
                },
                rows: rows,
            },
        ]
    }, [akaTitlesFromWork, currentAkaTitles, akaTitles])
}

export default AlternativeTitlesTableInfo
